'use client'

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/organisms/breadcrumb'
import { cn } from '@/lib/utils'
import Link from 'next/link'

interface GlobalBreadcrumbProps {
  currentLabel: string
  currentLink?: string
  previousLabel?: string
  previousLink?: string
  isFixed?: boolean
  onPreviousClick?: () => void
  mockSectionTitles?: string[]
  className?: string
}

export function GlobalBreadcrumb({
  currentLabel,
  currentLink,
  previousLabel,
  previousLink,
  onPreviousClick,
  mockSectionTitles = [],
  className,
}: GlobalBreadcrumbProps) {
  const isCurrentSection = mockSectionTitles.includes(currentLabel)

  return (
    <div className={cn(`bg-white w-full`, className)}>
      <div className="container max-w-[1140px] mx-auto pb-5">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <Link href="/">Treeunfe</Link>
            </BreadcrumbItem>
            {previousLabel && previousLink && (
              <>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <button
                    onClick={onPreviousClick}
                    className="text-sm text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
                  >
                    <Link href={previousLink}>{previousLabel}</Link>
                  </button>
                </BreadcrumbItem>
              </>
            )}
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              {isCurrentSection ? (
                <div className="text-black">{currentLabel}</div>
              ) : currentLink ? (
                <Link href={currentLink} className="text-black">
                  {currentLabel}
                </Link>
              ) : (
                <div className="text-black">{currentLabel}</div>
              )}
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </div>
  )
}
